import { setAIVoices } from './ai-voices-slices';

import type { AIVoice } from 'js/src/client';
import { ApiService } from 'js/src/client';
import { getAIVoiceById } from 'js/src/data/ai-voices-and-avatars/ai-voices/ai-voices-selectors';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch, RootState } from 'js/src/libs/RootState';

/**
 * @deprecated refactor your code to use the v2 endpoint which has pagination.
 */
export const fetchAIVoices = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceList();
            dispatch(setAIVoices(response.data));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};

export const fetchDefaultAIVoice = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceV2DefaultVoiceRetrieve();
            const voice = response.data;
            dispatch(setAIVoices([voice]));
            return voice;
        } catch (error) {
            ErrorReporter.capture(error);
            return null;
        }
    };
};

export const ensureAIVoiceLoaded = (slug: string, force = false) => {
    return async (dispatch: AppDispatch, getState: () => RootState): Promise<AIVoice | null> => {
        if (!force) {
            const existing = getAIVoiceById(getState(), slug);
            if (existing) {
                return existing;
            }
        }

        try {
            const response = await ApiService.aiVoiceV2BySlugRetrieve({
                path: { slug },
            });
            dispatch(setAIVoices([response.data]));
            return response.data;
        } catch (error) {
            ErrorReporter.capture(error, { level: 'warning' });
            return null;
        }
    };
};

export const fetchAIVoicesTastingMenu = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceV2TastingMenuList();
            dispatch(setAIVoices(response.data));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};
